import styles from './devRibbon.module.css'

const DevRibbon = () => <div className={styles.cornerRibbon}>Staging</div>
export default DevRibbon
